var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var SMALL_CARD_IMAGE_RESOLUTIONS = {
    large: 232,
    xlarge: 304,
    largest: 512
};
export var MEDIUM_CARD_IMAGE_RESOLUTIONS = {
    small: 160,
    medium: 342,
    large: 386,
    xlarge: 506,
    largest: 854
};
export var LARGE_CARD_IMAGE_RESOLUTIONS = {
    small: 240,
    medium: 512,
    large: 580,
    xlarge: 760,
    largest: 1280
};
export var LARGEST_CARD_IMAGE_RESOLUTIONS = {
    small: 480,
    medium: 1024,
    large: 1160,
    xlarge: 1520,
    largest: 2560
};
export var contentCardImageResolutions = new Map([
    ['SMALL', SMALL_CARD_IMAGE_RESOLUTIONS],
    ['MEDIUM', MEDIUM_CARD_IMAGE_RESOLUTIONS],
    ['LARGE', LARGE_CARD_IMAGE_RESOLUTIONS],
    ['LARGEST', LARGEST_CARD_IMAGE_RESOLUTIONS]
]);
export var createContentCardMapEntries = function (keys, value) {
    return keys.map(function (key) {
        return [key, contentCardImageResolutions.get(value)];
    });
};
export var getCtaLayout = function (layout, ctas) {
    var overlayCtas = [];
    var cardCtas = [];
    switch (layout) {
        case 'ALL_ON_CARD':
            cardCtas = ctas;
            break;
        case 'ALL_ON_OVERLAY':
            overlayCtas = ctas;
            break;
        default:
            if ((ctas === null || ctas === void 0 ? void 0 : ctas.length) === 1) {
                // Handle single CTA
                cardCtas = ctas.map(function (cta) { return (__assign(__assign({}, cta), { as: 'p' })); });
            }
            else {
                // First CTA is a dummy CTA
                cardCtas = ctas === null || ctas === void 0 ? void 0 : ctas.slice(0, 1).map(function (cta) { return (__assign(__assign({}, cta), { url: null, as: 'p' })); });
                overlayCtas = ctas === null || ctas === void 0 ? void 0 : ctas.slice(1);
            }
            break;
    }
    return { cardCtas: cardCtas, overlayCtas: overlayCtas };
};
export var contentCardSizeMappings = {
    MINI: 'CONTENT_CARD_MINI',
    REGULAR: 'CONTENT_CARD_REGULAR',
    MEGA: 'CONTENT_CARD_MEGA'
};
